<template>
  <div class="mt-5">
    <div class="flex flex-col">
      <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
        <div
          v-if="messageLogs.docs && messageLogs.docs.length > 0"
          class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
        >
          <table class="min-w-full">
            <thead>
              <tr class="hidden md:table-row">
                <th
                  class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  Phone Number
                </th>
                <th
                  class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  checkoutId
                </th>
                <th
                  class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  Message Status
                </th>
                <th
                  class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  Total
                </th>
                <th
                  class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  DATE
                </th>

                <th
                  class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  Whatsapp message
                </th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr
                class="grid grid-cols-2 grid-flow-row md:table-row"
                v-for="log in messageLogs.docs"
                :key="log.id"
              >
                <td
                  class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                >
                  {{ log.phoneNumber }}
                </td>
                <td
                  class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                >
                  {{ log.checkoutId }}
                </td>
                <td
                  class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                >
                  {{ log.messageStatus }}

                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                    v-if="log.channel === 'sms'"
                  >
                    sent as {{ log.channel }}
                  </span>
                </td>
                <td
                  class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                >
                  {{ log.totalPrice }}
                </td>
                <td
                  class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                >
                  {{ log.createdAt | dateFilter }}
                </td>
                <td
                  class="px-1 md:px-3 py-2 md:py-4 border-b border-gray-200 text-xs leading-5 font-medium text-gray-900 whitespace-pre-wrap"
                >
                  {{ log.body }}
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination :page="messageLogs" @pageChanged="loadPage" />
        </div>
        <div
          class="align-middle inline-block min-w-full  overflow-hidden text-center py-16"
          v-if="!isLoading && messageLogs.docs && messageLogs.docs.length === 0"
        >
          You don't have any message logs right now. We will be listing them
          here as soon as we sent a message.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

import Pagination from "../../components/Common/Pagination";

export default {
  name: "MessageLogs",
  components: {
    Pagination
  },
  filters: {
    dateFilter(value) {
      return format(new Date(value * 1000), "h:mm a, MMM dd");
    }
  },
  data() {
    return {
      messageLogs: {},
      isLoading: false
    };
  },
  created() {
    this.loadPage(1);
  },
  methods: {
    loadPage(page) {
      this.$store.dispatch("getMessageLog", { page }).then(response => {
        this.messageLogs = response.logs;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
